import React, { useState } from 'react';
import logo from '../../assets/logo.jpg';
import Cart from '../Cart/Cart';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import BrandsDropdown from './BrandsDropdown/BrandsDropdown';
import CategoriesDropdown from './CategoriesDropdown/CategoriesDropdown';
import SearchBar from './SearchBar/SearchBar';
import './TopbarMobile.scss';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../store/userStore'; 
import LoginPopup from '../LoginPopup/LoginPopup'; 
import MobileMenu from './MobileMenu/MobileMenu';
import SearchBarMobile from './SearchBar/SearchBarMobile';
import MobileAccount from './MobileAccount/MobileAccount';

export default function TopbarMobile() {
  const navigate = useNavigate();


  return (
    <div className="topbar-mobile">
      <div className="m-col m-col-1">

       <MobileMenu />
       <SearchBarMobile />
      </div>
      <div className="m-col m-col-2">
      <div className="logo" onClick={() => navigate(`/`)}>
          <img src={logo} alt="Logo" />
        </div>
        {/* <SearchBar />
        <CategoriesDropdown />
        <BrandsDropdown /> */}
      </div>
      <div className="m-col m-col-3">
      <MobileAccount />
        <Cart />
        </div>
        {/* <LanguageSwitcher /> */}
    

      
    </div>
  );
}